'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _paymentUtil = require('../../../../../../common/payment/paymentUtil');

var _currencyUtil = require('../../../../../../common/payment/currencyUtil');

var _paymentConstants = require('../../../../../../common/payment/paymentConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanBillingDetailSection = function PlanBillingDetailSection(_ref) {
    var subscriptionDetail = _ref.subscriptionDetail,
        isSubscriptionAdmin = _ref.isSubscriptionAdmin;

    if (!subscriptionDetail) return null;
    if (!isSubscriptionAdmin) return null;

    var coupon = subscriptionDetail.getIn(['discount', 'coupon']);
    var couponOb = coupon ? coupon.toJS() : {};

    var plan = subscriptionDetail.get('plan');
    var planCost = plan.get('amount');
    var interval = plan.get('interval');
    var volume = subscriptionDetail.get('quantity');

    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));
    var price = (0, _paymentUtil.centsToDollars)((0, _paymentUtil.calculateCouponDiscount)(couponOb, (0, _paymentUtil.convertPriceUnits)(planCost, interval, _paymentConstants.PRICE_BILLING_UNITS.month) * volume));

    var billingFrequency = (0, _paymentUtil.describeFrequency)(interval);

    return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
            'div',
            { className: 'detail' },
            _react2.default.createElement(
                'p',
                { className: 'section-title' },
                'You\'re paying ',
                currency,
                price,
                ' / month'
            ),
            _react2.default.createElement(
                'p',
                { className: 'paren' },
                'Billed ',
                billingFrequency,
                ' ',
                _react2.default.createElement('br', null)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'action' },
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/account/payment' },
                    'Change billing frequency'
                )
            )
        )
    );
};

PlanBillingDetailSection.propTypes = {
    subscriptionDetail: _propTypes2.default.object,
    isSubscriptionAdmin: _propTypes2.default.bool
};

exports.default = PlanBillingDetailSection;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/pro/planSections/PlanBillingDetailSection.js
// module id = 2069
// module chunks = 0